import { render, staticRenderFns } from "./Accountstable.vue?vue&type=template&id=07904c8e&"
import script from "./Accountstable.vue?vue&type=script&lang=js&"
export * from "./Accountstable.vue?vue&type=script&lang=js&"
import style0 from "./Accountstable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports